





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { mixins } from 'vue-class-component';
// import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Watch } from 'vue-property-decorator';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import { SwPanelGroup, SwPanel } from '@libs/unified-ui-framework/src/shared/sw-panel';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { State } from 'vuex-class';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import store, { RootStoreState } from '@/store';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { CoreStoreState } from '../../core.store';
import Ns from './../../../assets/ns.svg';
import ThirdPartyIcon from './../../../assets/Icon_ThirdParty_OrangeColor.svg';
import NGAV from './../../../assets/Icon_NG-AV_OrangeColor.svg';
import NGAVATP from './../../../assets/Icon_NG-AV+ATP_OrangeColor.svg';
import Waf from './../../../assets/Logo_WAF_OrangeColor.svg';
import Atp from './../../../assets/Icon_Capture_ATPw_RTDMI_OrangeColor.svg';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import CloudEmail from './../../../assets/Icon_Cloud_Email_Security_OrangeColor.svg';
import CASB from './../../../assets/Icon_CASB_Color.svg';
import IconEndpoint from './../../../assets/Icon_Endpoint_SSC_Color.svg';
import { Threat } from '../../../modules/sw-ftr-bill-meter/data';
import SwRmApiMixin from '../../sw-rm-api-mixin/sw-rm-api-mixin.vue';
/**
 * @event click `(event: MouseEvent)`
 */
@Component({
  components: {
    SwIcon,
    SwPanelGroup,
    SwPanel,
    SwTextfield,
    SwFormRow,
    SwButton,
    SwScrollView,
    SwForm,
  },
})
export default class SwSecurityBreakdown extends mixins(SwRmApiMixin) {

  @State((state: RootStoreState) => (state.CoreStoreModule.inEditMode))
  inEditMode: CoreStoreState['inEditMode'];
  @State((state: RootStoreState) => (state.CoreStoreModule.loadDetails))
  loadDetails: CoreStoreState['loadDetails'];
  @State((state: RootStoreState) => (state.CoreStoreModule.consolidatedThreats))
  consolidatedThreats: any | undefined;

  @State((state: RootStoreState) => (state.CoreStoreModule.tenantid))
  tenantid: string | undefined;
  @State((state: RootStoreState) => (state.CoreStoreModule.selectedTenantId))
  selectedTenantId: string;

  @State((state: RootStoreState) => (state.CoreStoreModule.waf))
  waf: string | undefined;
  @State((state: RootStoreState) => (state.CoreStoreModule.firewall))
  firewall: string;
  @State((state: RootStoreState) => (state.CoreStoreModule.email))
  email: string | undefined;
  @State((state: RootStoreState) => (state.CoreStoreModule.cloud))
  cloud: string;
  @State((state: RootStoreState) => (state.CoreStoreModule.nextgenav))
  nextgenav: string | undefined;

  @State((state: RootStoreState) => (state.CoreStoreModule.username))
  username: string | undefined;

  @State((state: RootStoreState) => (state.CoreStoreModule.threatPercent))
  threatPercent: number;
  consolidatedThreatObj: any;
  otherEndpointCompany: string = '';
  otherEmailCompany: string = '';
  otherCloudCompany: string = '';
  otherWafCompany: string = '';
  otherFirewallCompany: string = '';

  emailCompaniesList = [
    { name: 'Proofpoint', id: 'Proofpoint' },
    { name: 'Mimecast', id: 'Mimecast' },
    { name: 'Barracuda', id: 'Barracuda' },
    { name: 'FortiMail', id: 'FortiMail' },
    { name: 'Trend Micro', id: 'Trend Micro' },
    { name: 'Sophos', id: 'Sophos' },
    { name: 'Symantec', id: 'Symantec' },
    { name: 'Microsoft', id: 'Microsoft' },
  ];

  cloudCompaniesList = [
    { name: 'McAfee', id: 'McAfee' },
    { name: 'Netskope', id: 'Netskope' },
    { name: 'Microsoft', id: 'Microsoft' },
    { name: 'BitGlass', id: 'BitGlass' },
  ];
  firewallCompaniesList = [
    { name: 'Sophos', id: 'Sophos' },
    { name: 'Fortinet', id: 'Fortinet' },
    { name: 'Palo Alto', id: 'Palo Alto' },
    { name: 'Cisco', id: 'Cisco' },
    { name: 'Watchguard', id: 'Watchguard' },
    { name: 'Barracuda', id: 'Barracuda' },
  ];
  wafCompaniesList = [
    { name: 'Fortinet', id: 'Fortinet' },
    { name: 'Imperva', id: 'Imperva' },
    { name: 'Incapsula', id: 'Incapsula' },
    { name: 'Cloudflare', id: 'Cloudflare' },
    { name: 'Barracuda', id: 'Barracuda' },
  ];
  endpointCompaniesList = [
    { name: 'Webroot', id: 'Webroot' },
    { name: 'MalwareBytes', id: 'MalwareBytes' },
    { name: 'BitDefender', id: 'BitDefender' },
    { name: 'Kaspersky', id: 'Kaspersky' },
    { name: 'McAfee', id: 'McAfee' },
    { name: 'Symantec', id: 'Symantec' },
    { name: 'Trend Micro', id: 'Trend Micro' },
    { name: 'Crowdstrike', id: 'Crowdstrike' },
    { name: 'Carbon Black', id: 'Carbon Black' },
    { name: 'Sophos', id: 'Sophos' },
    { name: 'Microsoft Windows Defender', id: 'Microsoft Windows Defender' },
    { name: 'eset', id: 'eset' },
  ];
  endpointCompaniesListClone = [...this.endpointCompaniesList];
  emailCompaniesListClone = [...this.emailCompaniesList];
  wafCompaniesListClone = [...this.wafCompaniesList];
  cloudCompaniesListClone = [...this.cloudCompaniesList];
  firewallCompaniesListClone = [...this.firewallCompaniesList];
  selectEndpointCompany = '';
  wafSelectedCompany = '';
  selectedCloudCompany: string = '';
  cssPrefix: string = 'sw-security';
  showEndpointDetails: boolean = false;
  showBreakdownOptions: boolean = true;
  showCasBreakdownDetail: boolean = false;
  showCloudThirdPartyDetails: boolean = false;
  endpointThirdPartyDetails: boolean = false;
  showNetworkSecurityDetails: boolean = false;
  showCasEmailThirdPartyDetails: boolean = false;
  showFirewallThirdPartyDetails: boolean = false;
  showWafThirdPartyDetails: boolean = false;
  selected: string = '';
  firewallSelectedCompany: string = '';
  expandedPanels: string[] = [];
  filteredObj: any;
  globalCount: string = '0';
  regionalCount: string = '0';
  tenantCount : string = '0';
  region: string = '';
  globalCountEndPoint: any = [0, 0, 0, 0];
  regionalCountEndPoint: any = [0, 0, 0, 0];
  regionEndPoint: any = ['', '', '', ''];
  tenantCountEndPoint: any = [0, 0, 0, 0];
  globalCountCAS: any = [0, 0, 0, 0];
  regionalCountCAS: any = [0, 0, 0, 0];
  regionCAS: any = ['', '', '', ''];
  tenantCountCAS: any = [0, 0, 0, 0];
  globalCountNS: any = [0, 0, 0, 0];
  regionalCountNS: any = [0, 0, 0, 0];
  regionNS: any = ['', '', '', ''];
  tenantCountNS: any = [0, 0, 0, 0];
  innerContext: 'SonicOSx' | 'GMS' = 'SonicOSx';
  oneDay = 1000 * 60 * 60 * 4;
  oneDayAgo = new Date(Date.now() - this.oneDay).toLocaleDateString('en-US');
  threatCount = [];
  endpointMalwareTenantCount = 0;
  endpointExploitsTenantCount = 0;
  endpoint0DayAtpTenantCount = 0;
  rollbackTenantCount = 0;
  phishingTenantCount = 0;
  maliciousAttachmentsTenantCount = 0;
  malwareCloudTenantCount = 0;
  cloudDataLossTenantCount = 0;
  malwareTenantCount = 0;
  intrusionTenantCount = 0;
  webAppTenantCount = 0;
  zeroDayTenantCount = 0;
  nsImg = Ns;
  thirdPartyImg = ThirdPartyIcon;
  wafImg = Waf;
  casbImg = CASB;
  atpImg = Atp;
  ngImg = NGAV;
  ngAtp = NGAVATP;
  endpointImg = IconEndpoint;
  cloudEmailImg = CloudEmail;
  endpointMalwareData: any[] = [{
    id : 1,
    title : 'Endpoint Malware',
    summaryConfig: {
      text: '',
    },
  }];
  endpointExploitsData: any[] = [{
    id : 1,
    title : 'Endpoint Exploits',
    summaryConfig: {
      text: '',
    },
  }];
  phishingDatas: any[] = [{
    id : 1,
    title : 'Phishing',
    summaryConfig: {
      text: '',
    },
  }];
  maliciousDatas: any[] = [{
    id : 1,
    title : 'Malicious Attachments',
    summaryConfig: {
      text: '',
    },
  }];
  malwareOnCloudDatas: any[] = [{
    id : 1,
    title : 'Malware on Cloud',
    summaryConfig: {
      text: '',
    },
  }];
  cloudDatas: any[] = [{
    id : 1,
    title : 'Cloud Data Loss',
    summaryConfig: {
      text: '',
    },
  }];
  malwareDatas: any[] = [{
    id : 1,
    title : 'Malware',
    summaryConfig: {
      text: '',
    },
  }];
  zeroDayThreatsDatas: any[] = [{
    id : 1,
    title : '0 Day Threats',
    summaryConfig: {
      text: '',
    },
  }];
  webAppDatas: any[] = [{
    id : 1,
    title : 'Web App Attacks',
    summaryConfig: {
      text: '',
    },
  }];
  intrusionDatas: any[] = [{
    id : 1,
    title : 'Intrusion',
    summaryConfig: {
      text: '',
    },
  }];

  endpointZeroThreatData: any[] = [{
    id : 1,
    title : '0 Day Threats (ATP)',
    summaryConfig: {
      text: '',
    },
  }];
  rollbackData: any[] = [{
    id : 1,
    title : 'Rollbacks',
    summaryConfig: {
      text: '',
    },
  }];
  emailCompany: string = '';
  cloudCompany: string = '';
  wafCompany: string = '';
  nextGenCompany: string = '';
  firewallCompany: string = '';
  onSelectEndpointCompany(id: string) {
    this.setNextGenCompany(id);
  }
  setEndpointThirdPartyCompany() {
    if (this.nextGen.length > 0) {
      this.selectEndpointCompany = this.nextGen;
      this.layerOneInnerLayersActivatedLocal[0] = true;
      this.saveThirdPartyData(this.selectEndpointCompany, 'nextgenav');
      this.thirdPartyDetails.nextgenav = this.selectEndpointCompany;
      this.updateLayerPenetrating();
    }
  }
  removeEndpointCompany() {
    this.setNextGenCompany('');
    this.selectEndpointCompany = '';
    this.layerOneInnerLayersActivatedLocal[0] = false;
    this.saveThirdPartyData(this.selectEndpointCompany, 'nextgenav');
    this.thirdPartyDetails.nextgenav = this.selectEndpointCompany;
    this.updateLayerPenetrating();
  }
  isExists(arr: any, company: string) {
    let found = false;
    arr.filter((item: any) => {
      if (item.id === company) {
        found = true;
        return;
      }
    });
    return found;
  }
  isUnique(arr: any, cloneArr: any) {
    const uniqueArr = arr.filter((obj: any) => { return cloneArr.indexOf(obj) === -1; }) || [];
    return uniqueArr;
  }

  addEndPointCompany() {
    if (this.otherEndpointCompany.length && !this.isExists(this.endpointCompaniesList, this.otherEndpointCompany)) {
      const oCompany = this.isUnique(this.endpointCompaniesList, this.endpointCompaniesListClone);
      const customTxt = '(Custom)';
      const customCompanyName = `${this.otherEndpointCompany} ${customTxt} `;
      if (oCompany.length > 0) {
        const index = this.endpointCompaniesList.findIndex(x => x.id === oCompany[0].id);
        this.endpointCompaniesList[index].name = customCompanyName;
        this.endpointCompaniesList[index].id = customCompanyName;
        this.removeEndpointCompany();
      } else {
        this.endpointCompaniesList.push({ name: customCompanyName, id: customCompanyName });
      }
      this.onSelectEndpointCompany(customCompanyName);
      this.otherEndpointCompany = '';
    }
  }
  addEmailCompany() {
    if (this.otherEmailCompany.length && !this.isExists(this.emailCompaniesList, this.otherEmailCompany)) {
      const oCompany = this.isUnique(this.emailCompaniesList, this.emailCompaniesListClone);
      const customTxt = '(Custom)';
      const customCompanyName = `${this.otherEmailCompany} ${customTxt} `;
      if (oCompany.length > 0) {
        const index = this.emailCompaniesList.findIndex(x => x.id === oCompany[0].id);
        this.emailCompaniesList[index].name = customCompanyName;
        this.emailCompaniesList[index].id = customCompanyName;
        this.removeEmailCompany();
      } else {
        this.emailCompaniesList.push({ name: customCompanyName, id: customCompanyName });
      }
      this.onSelectCompany(customCompanyName);
      this.otherEmailCompany = '';
    }
  }
  addCloudCompany() {
    if (this.otherCloudCompany.length && !this.isExists(this.cloudCompaniesList, this.otherCloudCompany)) {
      const oCompany = this.isUnique(this.cloudCompaniesList, this.cloudCompaniesListClone);
      const customTxt = '(Custom)';
      const customCompanyName = `${this.otherCloudCompany} ${customTxt} `;
      if (oCompany.length > 0) {
        const index = this.cloudCompaniesList.findIndex(x => x.id === oCompany[0].id);
        this.cloudCompaniesList[index].name = customCompanyName;
        this.cloudCompaniesList[index].id = customCompanyName;
        this.removeEmailCompany();
      } else {
        this.cloudCompaniesList.push({ name: customCompanyName, id: customCompanyName });
      }
      this.onSelectCloudCompany(customCompanyName);
      this.otherCloudCompany = '';
    }
  }
  addFirewallCompany() {
    if (this.otherFirewallCompany.length && !this.isExists(this.firewallCompaniesList, this.otherFirewallCompany)) {
      const oCompany = this.isUnique(this.firewallCompaniesList, this.firewallCompaniesListClone);
      const customTxt = '(Custom)';
      const customCompanyName = `${this.otherFirewallCompany} ${customTxt} `;
      if (oCompany.length > 0) {
        const index = this.firewallCompaniesList.findIndex(x => x.id === oCompany[0].id);
        this.firewallCompaniesList[index].name = customCompanyName;
        this.firewallCompaniesList[index].id = customCompanyName;
        this.removeEmailCompany();
      } else {
        this.firewallCompaniesList.push({ name: customCompanyName, id: customCompanyName });
      }
      this.onSelectFirewallCompany(customCompanyName);
      this.otherFirewallCompany = '';
    }
  }
  addWafCompany() {
    if (this.otherWafCompany.length && !this.isExists(this.wafCompaniesList, this.otherWafCompany)) {
      const oCompany = this.isUnique(this.wafCompaniesList, this.wafCompaniesListClone);
      const customTxt = '(Custom)';
      const customCompanyName = `${this.otherWafCompany} ${customTxt} `;
      if (oCompany.length > 0) {
        const index = this.wafCompaniesList.findIndex(x => x.id === oCompany[0].id);
        this.wafCompaniesList[index].name = customCompanyName;
        this.wafCompaniesList[index].id = customCompanyName;
        this.removeEmailCompany();
      } else {
        this.wafCompaniesList.push({ name: customCompanyName, id: customCompanyName });
      }
      this.onSelectWafCompany(customCompanyName);
      this.otherWafCompany = '';
    }
  }
  get nextGen() {
    return this.nextGenCompany;
  }
  setNextGenCompany(val: string) {
    this.nextGenCompany = val;
  }
  get selectedEmailCompany() {
    return this.emailCompany;
  }
  setEmailCompany(val: string) {
    this.emailCompany = val;
  }
  get cloudCompanyFn() {
    return this.cloudCompany;
  }
  setCloudCompany(val: string) {
    this.cloudCompany = val;
  }
  get wafCompanyFn() {
    return this.wafCompany;
  }
  setWafCompany(val: string) {
    this.wafCompany = val;
  }
  get firewallCompanyFn() {
    return this.firewallCompany;
  }
  setFirewallThirdPartyCompany(val: string) {
    this.firewallCompany = val;
  }
  onSelectWafCompany(id: string) {
    this.setWafCompany(id);
  }
  setWafThirdPartyCompany() {
    if (this.wafCompanyFn.length > 0) {
      this.wafSelectedCompany = this.wafCompanyFn;
      this.layerThreeInnerLayersActivatedLocal[0] = true;
      this.saveThirdPartyData(this.wafSelectedCompany, 'waf');
      this.thirdPartyDetails.waf = this.wafSelectedCompany;
      this.updateLayerPenetrating();
    }
  }
  removeWafCompany() {
    this.setWafCompany('');
    this.wafSelectedCompany = '';
    this.layerThreeInnerLayersActivatedLocal[0] = false;
    this.saveThirdPartyData(this.wafSelectedCompany, 'waf');
    this.thirdPartyDetails.waf = this.wafSelectedCompany;
    this.updateLayerPenetrating();
  }
  setEmailCompanyFn() {
    if (this.selectedEmailCompany.length > 0) {
      this.selected = this.selectedEmailCompany;
      this.layerTwoInnerLayersActivatedLocal[0] = true;
      this.saveThirdPartyData(this.selected, 'email');
      this.thirdPartyDetails.email =  this.selected;
      this.updateLayerPenetrating();
    }
  }
  removeEmailCompany() {
    this.setEmailCompany('');
    this.selected = '';
    this.layerTwoInnerLayersActivatedLocal[0] = false;
    this.saveThirdPartyData(this.selected, 'email');
    this.thirdPartyDetails.email =  this.selected;
    this.updateLayerPenetrating();
  }
  setFirewallCompanyFn() {
    if (this.firewallCompanyFn.length > 0) {
      this.firewallSelectedCompany = this.firewallCompanyFn;
      this.layerThreeInnerLayersActivatedLocal[2] = true;
      this.saveThirdPartyData(this.firewallSelectedCompany, 'firewall');
      this.thirdPartyDetails.firewall = this.firewallSelectedCompany;
      this.updateLayerPenetrating();
    }
  }
  removeFirewallCompany() {
    this.setFirewallThirdPartyCompany('');
    this.firewallSelectedCompany = '';
    this.layerThreeInnerLayersActivatedLocal[2] = false;
    this.saveThirdPartyData(this.firewallSelectedCompany, 'firewall');
    this.thirdPartyDetails.firewall = this.firewallSelectedCompany;
    this.updateLayerPenetrating();
  }
  onSelectCompany(id: string) {
    this.setEmailCompany(id);
  }
  onSelectFirewallCompany(id: string) {
    this.setFirewallThirdPartyCompany(id);
  }
  setCloudCompanyFn() {
    if (this.cloudCompany.length > 0) {
      this.selectedCloudCompany = this.cloudCompany;
      this.saveThirdPartyData(this.selectedCloudCompany, 'cloud');
      this.thirdPartyDetails.cloud = this.selectedCloudCompany;
      this.layerTwoInnerLayersActivatedLocal[1] = true;
      this.updateLayerPenetrating();
    }
  }
  removeCloudCompany() {
    this.setCloudCompany('');
    this.selectedCloudCompany = '';
    this.layerTwoInnerLayersActivatedLocal[1] = false;
    this.saveThirdPartyData(this.selectedCloudCompany, 'cloud');
    this.thirdPartyDetails.cloud = this.selectedCloudCompany;
    this.updateLayerPenetrating();
  }
  onSelectCloudCompany(id: string) {
    this.setCloudCompany(id);
  }
  layerThreeInnerLayersActivatedLocal = [true, true, true];
  layerTwoInnerLayersActivatedLocal = [true, true];
  layerOneInnerLayersActivatedLocal = [true, true];
  @Watch('threatsLocal')
  commitThreats() {
    store.commit('setThreats', { threats: this.threatsLocal });
  }
  @Watch('inEditMode')
  hideThirdPartyDetails() {
    if (!this.inEditMode) {
      this.showWafThirdPartyDetails = false;
      this.showCloudThirdPartyDetails = false;
      this.showCasEmailThirdPartyDetails = false;
      this.showFirewallThirdPartyDetails = false;
      this.endpointThirdPartyDetails = false;
    }
  }
  @Watch('layerOneInnerLayersActivatedLocal')
  commitLayerOne() {
    store.commit('setToggleLayerOneActivated', { layerOneInnerLayersActivated: this.layerOneInnerLayersActivatedLocal });
  }
  @Watch('layerTwoInnerLayersActivatedLocal')
  commitLayerTwo() {
    store.commit('setToggleLayerTwoActivated', { layerTwoInnerLayersActivated: this.layerTwoInnerLayersActivatedLocal });
  }
  @Watch('layerThreeInnerLayersActivatedLocal')
  commitLayerThree() {
    store.commit('setToggleLayerThreeActivated', { layerThreeInnerLayersActivated: this.layerThreeInnerLayersActivatedLocal });
  }

  updateLayerPenetrating() {
    for (let i = 0; i < this.threatsLocal.length; i += 1) {
      if (this.threatsLocal[i].show || true) {
        const threat = this.threatsLocal[i];
        if (threat.layer === 3) {
          if (threat.innerLayer !== undefined && this.layerThreeInnerLayersActivatedLocal[threat.innerLayer]) {
            if (threat.innerLayer === 0 && this.wafSelectedCompany.length > 0) {
              this.threatsLocal[i].isPenetrating = false;
            } else {
              this.threatsLocal[i].isPenetrating = true;
            }
            if (threat.innerLayer === 2 && this.firewallSelectedCompany.length > 0 && (threat.title === 'Malware' || threat.title === 'Intrusion')) {
              this.threatsLocal[i].isPenetrating = false;
            } else {
              this.threatsLocal[i].isPenetrating = true;
            }
          } else {
            this.threatsLocal[i].isPenetrating = true;
          }
        } else if (threat.layer === 2) {
          if (threat.innerLayer !== undefined && this.layerTwoInnerLayersActivatedLocal[threat.innerLayer]) {
            if (threat.innerLayer === 0 && this.selected.length > 0 && threat.title === 'Phishing') {
              this.threatsLocal[i].isPenetrating = false;
            } else {
              this.threatsLocal[i].isPenetrating = true;
            }
            if (threat.innerLayer === 1 && this.selectedCloudCompany.length > 0 && threat.title === 'Cloud Data Loss') {
              this.threatsLocal[i].isPenetrating = false;
            } else {
              this.threatsLocal[i].isPenetrating = true;
            }
          } else {
            this.threatsLocal[i].isPenetrating = true;
          }
        } else if (threat.layer === 1) {
          if (threat.innerLayer !== undefined && this.layerOneInnerLayersActivatedLocal[threat.innerLayer]) {
            if (threat.innerLayer === 0 && this.selectEndpointCompany.length > 0 && (threat.title === 'Endpoint Malware' ||
             threat.title === 'Endpoint Exploits')) {
              this.threatsLocal[i].isPenetrating = false;
            } else {
              this.threatsLocal[i].isPenetrating = true;
            }
          } else {
            this.threatsLocal[i].isPenetrating = true;
          }
        }
      }
    }
    this.calculateAllLAyers();
  }

  @State((state: RootStoreState) => (state.CoreStoreModule.defcon))
  defcon: number;
  @State((state: RootStoreState) => (state.CoreStoreModule.defconPrecise))
  defconPrecise: number;

  defconPrecise1: number = this.defconPrecise;
  defcon1: number = this.defcon;

  @Watch('layerThreeInnerLayersActivatedLocal', { immediate: true, deep: true })
  @Watch('layerTwoInnerLayersActivatedLocal', { immediate: true, deep: true })
  @Watch('layerOneInnerLayersActivatedLocal', { immediate: true, deep: true })
  updateDefcon() {
    // if (this.loading) {
    //   return;
    // }
    let defconCounted = 0;
    let defconTotal = 0;
    this.threatsLocal.forEach((threat:Threat) => {
      defconTotal += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      if (!threat.isPenetrating) {
        defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      } else if (threat.innerLayer === 2 && this.thirdPartyDetails.firewall !== null && this.thirdPartyDetails.firewall !== '' && (threat.title ===
             'Malware' || threat.title === 'Intrusion')) {
        defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      } else if (threat.innerLayer === 0 && this.thirdPartyDetails.email !== null && this.thirdPartyDetails.email !== '' && threat.title === 'Phishing') {
        defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      } else if (threat.innerLayer === 1 && this.thirdPartyDetails.cloud !== null && this.thirdPartyDetails.cloud !== '' && threat.title ===
       'Cloud Data Loss') {
        defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      } else if (threat.innerLayer === 0 && this.thirdPartyDetails.nextgenav !== null && this.thirdPartyDetails.nextgenav !== '' && (threat.title ===
             'Endpoint Malware' || threat.title === 'Endpoint Exploits')) {
        defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      } else if (threat.innerLayer === 0 && this.thirdPartyDetails.waf !== null && this.thirdPartyDetails.waf !== '') {
        defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      }
    });
    this.defconPrecise1 = (4 * defconCounted / defconTotal) + 1;
    if (this.defconPrecise1 > 4 && this.defconPrecise1 < 5) {
      this.defcon1 = 4;
    } else if (this.defconPrecise1 < 2 && this.defconPrecise1 > 1) {
      this.defcon1 = 2;
    } else {
      this.defcon1 = Math.round(this.defconPrecise1);
    }
  }

  handlePanelChange(expandedPanels: string[], filterByTitle: string) {
    this.expandedPanels = expandedPanels.slice(0);
    if (this.expandedPanels) {
      this.populateData(filterByTitle);
    }
  }
  calculateSubLayer10: number = 0;
  calculateSubLayer11: number = 0;
  calculateSubLayer20: number = 0;
  calculateSubLayer21: number = 0;
  calculateSubLayer30: number = 0;
  calculateSubLayer31: number = 0;
  calculateSubLayer32: number = 0;
  calculateLayer1: number = 0;
  calculateLayer2: number = 0;
  calculateLayer3: number = 0;
  threatsLocal: Threat[] = [];
  get getSubLayer2() {
    return this.calculateSubLayer20 + this.calculateSubLayer21;
  }
  get getSubLayer1() {
    return this.calculateSubLayer10 + this.calculateSubLayer11;
  }
  get getSubLayer3() {
    return this.calculateSubLayer30 + this.calculateSubLayer31 + this.calculateSubLayer32;
  }
  @State((state: RootStoreState) => (state.CoreStoreModule.weights))
  weights:any;

  @State((state: RootStoreState) => (state.CoreStoreModule.layerOneInnerLayersActivated))
  layerOneInnerLayersActivated: any;

  @State((state: RootStoreState) => (state.CoreStoreModule.layerTwoInnerLayersActivated))
  layerTwoInnerLayersActivated: any;

  @State((state: RootStoreState) => (state.CoreStoreModule.layerThreeInnerLayersActivated))
  layerThreeInnerLayersActivated: any;

  calculateLayer(layer: number) {
    let defconCounted = 0;
    const defconTotal = 55;
    this.threatsLocal.forEach((threat:Threat) => {
      // defconTotal += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
      if (layer === 1) {
        if (threat.innerLayer !== undefined && this.layerOneInnerLayersActivated[threat.innerLayer] && layer === threat.layer && threat.show) {
          defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
        }
      }
      if (layer === 2) {
        if (threat.innerLayer !== undefined && this.layerTwoInnerLayersActivated[threat.innerLayer] && layer === threat.layer && threat.show) {
          defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
        }
      }
      if (layer === 3) {
        if (threat.innerLayer !== undefined && this.layerThreeInnerLayersActivated[threat.innerLayer] && layer === threat.layer && threat.show) {
          defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
        }
      }
    });
    const val = Math.ceil(defconCounted / defconTotal * 100);
    return val;
  }

  @Watch('threatsLocal')
  calculateAllLAyers() {
    // localStorage.setItem('threatsPercent', '0');
    store.commit('setThreatPercent', { threatPercent: 0 });
    if (this.thirdPartyDetails.nextgenav !== null && this.thirdPartyDetails.nextgenav !== '') {
      this.calculateSubLayer10 = 11;
    } else {
      this.calculateSubLayer10 = this.calculateSubLayer(1, 0);
    }
    this.calculateSubLayer11 = this.calculateSubLayer(1, 1) === 21 ? 22 : this.calculateSubLayer(1, 1);
    if (this.thirdPartyDetails.cloud !== null && this.thirdPartyDetails.cloud !== '') {
      this.calculateSubLayer21 = 3;
    } else {
      this.calculateSubLayer21 = this.calculateSubLayer(2, 1);
    }
    if (this.thirdPartyDetails.email !== null && this.thirdPartyDetails.email !== '') {
      this.calculateSubLayer20 = 2;
    } else {
      this.calculateSubLayer20 = this.calculateSubLayer(2, 0);
    }
    if (this.thirdPartyDetails.firewall !== null && this.thirdPartyDetails.firewall !== '') {
      this.calculateSubLayer32 = 22;
    } else {
      this.calculateSubLayer32 = this.calculateSubLayer(3, 2) === 21 ? 22 : this.calculateSubLayer(3, 2);
    }
    if (this.thirdPartyDetails.waf !== null && this.thirdPartyDetails.waf !== '') {
      this.calculateSubLayer30 = 16;
    } else {
      this.calculateSubLayer30 = this.calculateSubLayer(3, 0);
    }
    this.calculateSubLayer31 = this.calculateSubLayer(3, 1) === 16 ? 17 : this.calculateSubLayer(3, 1);
    const val = this.calculateSubLayer10 + this.calculateSubLayer11 + this.calculateSubLayer20 + this.calculateSubLayer21
    + this.calculateSubLayer30 + this.calculateSubLayer31 + this.calculateSubLayer32;
    // const percent = this.threatPercent && this.threatPercent !== null ?
    //  Number(this.threatPercent) : 0;
    // localStorage.setItem('threatsPercent', (percent + val).toString());
    store.commit('setThreatPercent', { threatPercent: val });
  }

  calculateSubLayer(layer: number, subLayer: number) {
    let defconCounted = 0;
    const defconTotal = 55;
    this.threatsLocal.forEach((threat:Threat) => {
      if (layer === 1) {
        if (threat.innerLayer !== undefined && this.layerOneInnerLayersActivated[threat.innerLayer] && layer === threat.layer &&
         subLayer === threat.innerLayer  && threat.show) {
          defconCounted += (this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex]);
        }
      }
      if (layer === 2) {
        if (threat.innerLayer !== undefined && this.layerTwoInnerLayersActivated[threat.innerLayer] &&
         layer === threat.layer && subLayer === threat.innerLayer  && threat.show) {
          defconCounted += (this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex]);
        }
      }
      if (layer === 3) {
        if (threat.innerLayer !== undefined && this.layerThreeInnerLayersActivated[threat.innerLayer] &&
         layer === threat.layer && subLayer === threat.innerLayer  && threat.show) {
          defconCounted += (this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex]);
        }
      }
    });
    const val = Math.floor(defconCounted / defconTotal * 100);
    return val;
  }

  filter(title: string) {
    for (const item in this.consolidatedThreatObj) {
      if (this.consolidatedThreatObj[item].title === title) {
        return this.consolidatedThreatObj[item];
      }
    }
  }

  getTenantCount(filterByTitle: string) {
    this.filteredObj = this.filter(filterByTitle);
    if (this.selectedTenantId) {
      this.tenantCount = this.filteredObj['tenants'][this.selectedTenantId] !== undefined ? this.filteredObj['tenants'][this.selectedTenantId]['count'] : '-1';
      this.tenantCount === '-1' ? this.tenantCount = '0' : this.tenantCount;
    }
    return parseInt(this.tenantCount, 10);
  }

  populateThreatData(section: string) {
    if (section === 'endpoint-security') {
      this.endpointMalwareTenantCount = this.getTenantCount('Endpoint Malware');
      this.endpointExploitsTenantCount = this.getTenantCount('Endpoint Exploits');
      this.endpointExploitsTenantCount = this.getTenantCount('0 Day Threats (ATP)');
      this.rollbackTenantCount = this.getTenantCount('Rollbacks');
    } else if (section === 'cas-email') {
      this.phishingTenantCount = this.getTenantCount('Phishing');
      this.maliciousAttachmentsTenantCount = this.getTenantCount('Malicious Attatchments');
      this.malwareCloudTenantCount = this.getTenantCount('Malware on Cloud');
      this.cloudDataLossTenantCount = this.getTenantCount('Cloud Data Loss');
    } else if (section === 'network-security') {
      this.malwareTenantCount = this.getTenantCount('Malware');
      this.intrusionTenantCount = this.getTenantCount('Intrusion');
      this.webAppTenantCount = this.getTenantCount('Web App Attacks');
      this.zeroDayTenantCount = this.getTenantCount('0 Day Threats');
    }
  }

  @State((state: RootStoreState) => (state.CoreStoreModule.threats))
  threats: any | undefined;
  created() {
    this.consolidatedThreatObj =  this.consolidatedThreats;
    // tslint:disable-next-line
    const allThreats = ['Endpoint Malware', 'Endpoint Exploits', '0 Day Threats (ATP)', 'Rollbacks', 'Malware', 'Intrusion', 'Web App Attacks', '0 Day Threats', 'Phishing', 'Malicious Attatchments', 'Malware on Cloud', 'Cloud Data Loss'];
    this.threatsLocal = this.threats;
    this.processThreatData();
    this.layerOneInnerLayersActivatedLocal = this.layerOneInnerLayersActivated;
    this.layerTwoInnerLayersActivatedLocal = this.layerTwoInnerLayersActivated;
    this.layerThreeInnerLayersActivatedLocal = this.layerThreeInnerLayersActivated;
    this.setThirdPartyDetails();
    // localStorage.setItem('threatsPercent', '0');
    store.commit('setThreatPercent', { threatPercent: 0 });
    this.calculateAllLAyers();
    for (const i in allThreats) {
      this.populateData(allThreats[i]);
    }
  }

  isThirdPartyCompany(arr: any[], val: string) {
    // Find if the array contains an object by comparing the property value
    if (arr.some(company => company.id === val)) {
      return true;
    }
    return false;
  }

  @State((state: RootStoreState) => (state.CoreStoreModule.thirdParty))
  thirdParty: any | undefined;
  setThirdPartyDetails() {
    this.thirdPartyDetails = this.thirdParty.filter((item: any) => {
      return item.id === this.selectedTenantId;
    })[0];
    if (this.thirdPartyDetails.nextgenav !== undefined && this.thirdPartyDetails.nextgenav !== null && this.thirdPartyDetails.nextgenav !== '') {
      if (!this.isThirdPartyCompany(this.endpointCompaniesList, this.thirdPartyDetails.nextgenav)) {
        this.endpointCompaniesList.push({ name: this.thirdPartyDetails.nextgenav, id: this.thirdPartyDetails.nextgenav });
      }
      this.setNextGenCompany(this.thirdPartyDetails.nextgenav);
      this.onSelectEndpointCompany(this.thirdPartyDetails.nextgenav);
      this.setEndpointThirdPartyCompany();
    } else if (this.thirdPartyDetails.nextgenav === null) {
      this.selectEndpointCompany = '';
      // this.setNextGenCompany('');
    }
    if (this.thirdPartyDetails.waf !== undefined && this.thirdPartyDetails.waf !== null && this.thirdPartyDetails.waf !== '') {
      if (!this.isThirdPartyCompany(this.wafCompaniesList, this.thirdPartyDetails.waf)) {
        this.wafCompaniesList.push({ name: this.thirdPartyDetails.waf, id: this.thirdPartyDetails.waf });
      }
      this.setWafCompany(this.thirdPartyDetails.waf);
      this.onSelectWafCompany(this.thirdPartyDetails.waf);
      // this.wafSelectedCompany = this.thirdPartyDetails.waf;
      this.setWafThirdPartyCompany();
    } else if (this.thirdPartyDetails.waf === null) {
      // this.setWafCompany('');
      this.wafSelectedCompany = '';
    }
    if (this.thirdPartyDetails.firewall !== undefined && this.thirdPartyDetails.firewall !== null && this.thirdPartyDetails.firewall !== '') {
      if (!this.isThirdPartyCompany(this.firewallCompaniesList, this.thirdPartyDetails.firewall)) {
        this.firewallCompaniesList.push({ name: this.thirdPartyDetails.firewall, id: this.thirdPartyDetails.firewall });
      }
      this.setFirewallThirdPartyCompany(this.thirdPartyDetails.firewall);
      this.onSelectFirewallCompany(this.thirdPartyDetails.firewall);
      this.setFirewallCompanyFn();
      // this.firewallSelectedCompany = this.thirdPartyDetails.firewall;
    } else if (this.thirdPartyDetails.firewall === null && this.thirdPartyDetails.firewall === '') {
      // this.setFirewallThirdPartyCompany('');
      this.firewallSelectedCompany = '';
    }
    if (this.thirdPartyDetails.cloud !== undefined && this.thirdPartyDetails.cloud !== null && this.thirdPartyDetails.cloud !== '') {
      if (!this.isThirdPartyCompany(this.cloudCompaniesList, this.thirdPartyDetails.cloud)) {
        this.cloudCompaniesList.push({ name: this.thirdPartyDetails.cloud, id: this.thirdPartyDetails.cloud });
      }
      this.setCloudCompany(this.thirdPartyDetails.cloud);
      this.onSelectCloudCompany(this.thirdPartyDetails.cloud);
      this.setCloudCompanyFn();
      // this.selectedCloudCompany = this.thirdPartyDetails.cloud;
    } else {
      this.selectedCloudCompany = '';
    }
    if (this.thirdPartyDetails.email !== undefined && this.thirdPartyDetails.email !== null && this.thirdPartyDetails.email !== '') {
      if (!this.isThirdPartyCompany(this.emailCompaniesList, this.thirdPartyDetails.email)) {
        this.emailCompaniesList.push({ name: this.thirdPartyDetails.email, id: this.thirdPartyDetails.email });
      }
      this.setEmailCompany(this.thirdPartyDetails.email);
      this.onSelectCompany(this.thirdPartyDetails.email);
      this.setEmailCompanyFn();
      // this.selected = this.thirdPartyDetails.email;
    } else if (this.thirdPartyDetails.email === null) {
      this.selected = '';
      // this.setEmailCompany('');
    }
    // this.updateLayerPenetrating();
  }
  processThreatData() {
    for (let i = 0; i < this.threatsLocal.length; i = i + 1) {
      this.threatsLocal[i].globalIndex = i;
    }
    // this.threatsLocal = this.threatsLocal.filter(threat => threat.show);
  }

  updated() {
    // console.log(this.layerOneInnerLayersActivated, this.layerTwoInnerLayersActivated, this.layerThreeInnerLayersActivated);
    // this.threatsLocal = this.threats;
    // this.processThreatData();
    this.setThirdPartyDetails();
    // localStorage.setItem('threatsPercent', '0');
    store.commit('setThreatPercent', { threatPercent: 0 });
    this.calculateAllLAyers();
    this.updateDefcon();
    this.layerOneInnerLayersActivatedLocal = this.layerOneInnerLayersActivated;
    this.layerTwoInnerLayersActivatedLocal = this.layerTwoInnerLayersActivated;
    this.layerThreeInnerLayersActivatedLocal = this.layerThreeInnerLayersActivated;
  }

  countWithCommas(count: string) {
    const counter = Number(count);
    return String(counter < 1 && counter > 0 ? 1 : (Math.round(counter))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  afterDestroy() {
    if (this.threatPercent > 0) {
      store.commit('setThreatPercent', { threatPercent: 0 });
    }
  }

  populateData(filterByTitle: string) {
    this.filteredObj = this.filter(filterByTitle);
    this.filteredObj.globalAverage ? (this.globalCount = (this.countWithCommas(this.filteredObj.globalAverage))) : (this.globalCount = '0');
    this.filteredObj.regionalAverage ? (this.regionalCount = String(this.countWithCommas(this.filteredObj.regionalAverage))) : (this.regionalCount = 'N/A');
    this.filteredObj.region ? (this.region = this.filteredObj.region) : (this.region = '');
    console.warn(this.region);
    if (this.selectedTenantId) {
      // tslint:disable-next-line
      this.tenantCount = this.filteredObj['tenants'][this.selectedTenantId] !== undefined ? String(this.countWithCommas(this.filteredObj['tenants'][this.selectedTenantId]['count'])) : '-1';
      this.tenantCount === '-1' ? this.tenantCount = '0' : this.tenantCount;
    }

    // return [this.globalCount, this.regionalCount, this.tenantCount];

    if (filterByTitle === 'Endpoint Malware') {
      this.globalCountEndPoint[0] = this.globalCount;
      this.regionalCountEndPoint[0] = this.regionalCount;
      this.tenantCountEndPoint[0] = this.tenantCount;
      this.regionEndPoint[0] = this.region;
    } else if (filterByTitle === 'Endpoint Exploits') {
      this.globalCountEndPoint[1] = this.globalCount;
      this.regionalCountEndPoint[1] = this.regionalCount;
      this.tenantCountEndPoint[1] = this.tenantCount;
      this.regionEndPoint[1] = this.region;
    } else if (filterByTitle === '0 Day Threats (ATP)') {
      this.globalCountEndPoint[2] = this.globalCount;
      this.regionalCountEndPoint[2] = this.regionalCount;
      this.tenantCountEndPoint[2] = this.tenantCount;
      this.regionEndPoint[2] = this.region;
    } else if (filterByTitle === 'Rollbacks') {
      this.globalCountEndPoint[3] = this.globalCount;
      this.regionalCountEndPoint[3] = this.regionalCount;
      this.tenantCountEndPoint[3] = this.tenantCount;
      this.regionEndPoint[3] = this.region;
    }
    if (filterByTitle === 'Malware') {
      this.globalCountNS[0] = this.globalCount;
      this.regionalCountNS[0] = this.regionalCount;
      this.tenantCountNS[0] = this.tenantCount;
      this.regionNS[0] = this.region;
    } else if (filterByTitle === 'Intrusion') {
      this.globalCountNS[1] = this.globalCount;
      this.regionalCountNS[1] = this.regionalCount;
      this.tenantCountNS[1] = this.tenantCount;
      this.regionNS[1] = this.region;
    } else if (filterByTitle === 'Web App Attacks') {
      this.globalCountNS[2] = this.globalCount;
      this.regionalCountNS[2] = this.regionalCount;
      this.tenantCountNS[2] = this.tenantCount;
      this.regionNS[2] = this.region;
    } else if (filterByTitle === '0 Day Threats') {
      this.globalCountNS[3] = this.globalCount;
      this.regionalCountNS[3] = this.regionalCount;
      this.tenantCountNS[3] = this.tenantCount;
      this.regionNS[3] = this.region;
    }

    if (filterByTitle === 'Phishing') {
      this.globalCountCAS[0] = this.globalCount;
      this.regionalCountCAS[0] = this.regionalCount;
      this.tenantCountCAS[0] = this.tenantCount;
      this.regionCAS[0] = this.region;
    } else if (filterByTitle === 'Malicious Attatchments') {
      this.globalCountCAS[1] = this.globalCount;
      this.regionalCountCAS[1] = this.regionalCount;
      this.tenantCountCAS[1] = this.tenantCount;
      this.regionCAS[1] = this.region;
    } else if (filterByTitle === 'Malware on Cloud') {
      this.globalCountCAS[2] = this.globalCount;
      this.regionalCountCAS[2] = this.regionalCount;
      this.tenantCountCAS[2] = this.tenantCount;
      this.regionCAS[2] = this.region;
    } else if (filterByTitle === 'Cloud Data Loss') {
      this.globalCountCAS[3] = this.globalCount;
      this.regionalCountCAS[3] = this.regionalCount;
      this.tenantCountCAS[3] = this.tenantCount;
      this.regionCAS[3] = this.region;
    }
  }

  onClickIcon(section: string) {
    this.showBreakdownOptions = false;
    store.commit('setNavMode', { inEditMode: true });
    store.commit('setDetailMode', { loadDetails: false });
    if (section === 'endpoint-security') {
      this.showEndpointDetails = true;
      this.showNetworkSecurityDetails = false;
      this.showCasBreakdownDetail = false;
      this.showCasEmailThirdPartyDetails = false;
      this.showFirewallThirdPartyDetails = false;
      this.populateThreatData(section);
    } else if (section === 'cas-email') {
      this.showCasBreakdownDetail = true;
      this.showEndpointDetails = false;
      this.showNetworkSecurityDetails = false;
    } else if (section === 'network-security') {
      this.showCasBreakdownDetail = false;
      this.showEndpointDetails = false;
      this.showCasEmailThirdPartyDetails = false;
      this.showNetworkSecurityDetails = true;
    }
  }

  editThirdPartyDetails(e: Event, flag: boolean, id: string) {
    if (!flag) {
      e.stopImmediatePropagation();
      return(false);
    }
    this.showBreakdownOptions = false;
    if (id === 'cas-email-security')  {
      this.showCasEmailThirdPartyDetails = true;
      this.showCasBreakdownDetail = false;
      this.showCloudThirdPartyDetails = false;
    } else if (id === 'firewall') {
      this.showCasEmailThirdPartyDetails = false;
      this.showCasBreakdownDetail = false;
      this.showNetworkSecurityDetails = false;
      this.showFirewallThirdPartyDetails = true;
      this.showWafThirdPartyDetails = false;
    } else if (id === 'cas-cloud-security') {
      this.showCasEmailThirdPartyDetails = false;
      this.showCasBreakdownDetail = false;
      this.showNetworkSecurityDetails = false;
      this.showFirewallThirdPartyDetails = false;
      this.showCloudThirdPartyDetails = true;
      this.showWafThirdPartyDetails = false;
    } else if (id === 'waf') {
      this.showCasEmailThirdPartyDetails = false;
      this.showCasBreakdownDetail = false;
      this.showNetworkSecurityDetails = false;
      this.showFirewallThirdPartyDetails = false;
      this.showWafThirdPartyDetails = true;
    } else {
      this.showCasEmailThirdPartyDetails = true;
      this.showCasEmailThirdPartyDetails = false;
      this.showCasBreakdownDetail = false;
    }
  }
  onClickEdit(e: Event, flag: boolean, id: string) {
    if (!flag) {
      e.stopImmediatePropagation();
      return(false);
    }
    this.showBreakdownOptions = false;
    if (id === 'endpoint-security') {
      this.endpointThirdPartyDetails = true;
      this.showEndpointDetails = false;
    }
  }

}
